<template>
  <!-- используется на странице кейсов в банере -->
  <div class="t-reg-event__wrap">
    <div class="t-form__wrap2">
      <h2 class="t-reg-event__title" v-html="props.title"></h2>
      <div class="t-form__subtext" v-html="props.subtext"></div>

      <form class="t-form t-reg-event-form" :class="{ _disabled: infoForm.disabledForm }" @submit.stop.prevent="submitForm()">
        <div class="t-form__container">
          <div
            class="t-feedback__item t-form__item-half"
            v-for="(item, index) in form"
            :class="{ _50: item.type !== 'textarea', _full: item.type === 'textarea' }"
          >
            <div class="t-form__label" :class="{ '_radio-collab': item.type === 'radio' }">
              {{ item.label }}
              <span v-if="item.required || item.type === 'radio'">*</span>
            </div>

            <input
              v-if="item.type === 'text'"
              class="t-input"
              :class="{ _error: item.error, _valid: item.valid }"
              :type="item.type"
              :placeholder="item.placeholder"
              v-model="item.value"
              @focus="focusForm(index)"
            />
            <masked-input
              v-if="item.type === 'phone'"
              class="t-input"
              :class="{ _error: item.error, _valid: item.valid }"
              mask="\+\7(111)111-11-11"
              :placeholder="item.placeholder"
              v-model="item.value"
              :name="item.name"
              @input="focusForm(index)"
              :ref="index"
            />
            <textarea
              v-if="item.type === 'textarea'"
              class="t-textarea"
              :class="{ _error: item.error, _valid: item.valid }"
              :placeholder="item.placeholder"
              @input="focusForm(index)"
              v-model="item.value"
            >
            </textarea>

            <svg class="t-form__error-svg" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L9 9" stroke="white" stroke-width="2" />
              <path d="M9 1L1 9" stroke="white" stroke-width="2" />
            </svg>
          </div>
        </div>

        <div v-if="!$route.fullPath.includes('/lk')" class="t-personal-data _collab" :class="{ _error: infoForm.errorPersonalData }">
          <input @change="changePersonalDataFrom()" type="checkbox" id="personal-data5" class="t-personal-data__input" />
          <label for="personal-data5">
            <svg width="16" height="12" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.4213 0.944336L11.3327 1.63582L4.82917 7.88078C4.71347 7.99188 4.54763 8.05545 4.37347 8.05545C4.19932 8.05545 4.03347 7.99188 3.91777 7.88078L0.666016 4.7583L1.57741 4.06681L4.37347 6.75171L10.4213 0.944336Z"
                fill="white"
              />
            </svg>
            {{ $root.staticText.forms.agree }}
            <a href="/user-agreement" target="_blank" class="t-personal-data__link">
              {{ $root.staticText.forms.personalData }}
            </a>
          </label>
        </div>

        <vue-recaptcha
          ref="recaptcha"
          size="invisible"
          :sitekey="$root.sitekeyRecaptcha"
          :load-recaptcha-script="true"
          @verify="onCapchaRegister"
          @expired="onCaptchaExpired"
          @error="errorCaptcha"
        />
        <button class="t-btn _green _big t-feedback__btn _collab">{{ $root.staticText.forms.btn2 }}</button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import success from './success'
import error from './error'
import { validate, sendForm, changePersonalDataFrom, focusForm } from '@assets/js/formObjects.js'
import VueRecaptcha from 'vue-recaptcha'

export default {
  name: 'feedback',
  props: ['props'],
  data() {
    return {
      recaptchaToken: null,
      isValid: false,
      infoForm: {
        action: 'feedbackFullVersion',
        disabledForm: false,
        isPersonalData: false,
        errorPersonalData: false,
        success: false,
        error: false,
      },
      form: [
        {
          label: this.$root.staticText.forms.fullName,
          name: 'name',
          type: 'text',
          value: '',
          placeholder: this.$root.staticText.forms.placeholderFullName,
          error: false,
          valid: false,
          required: true,
          pattern: /[a-zа-яё]{2,}/i,
        },
        {
          label: this.$root.staticText.forms.company,
          name: 'company',
          type: 'text',
          value: '',
          placeholder: this.$root.staticText.forms.placeholderCompany2,
          error: false,
          valid: false,
          required: true,
          pattern: /\S{2,}/i,
        },
        {
          label: this.$root.staticText.forms.email,
          name: 'email',
          type: 'text',
          value: '',
          placeholder: this.$root.staticText.forms.placeholderEmail,
          error: false,
          valid: false,
          required: true,
          pattern: /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i,
        },
        {
          label: this.$root.staticText.forms.phone,
          name: 'phone',
          type: 'phone',
          value: '',
          placeholder: '+7',
          error: false,
          valid: false,
          required: true,
          pattern: /^\+\d{1,3}\s?\(\d{3}\)\s?\d{3}(-\d{2}){2}$/,
        },
        {
          label: this.$root.staticText.forms.comment2,
          name: 'comment',
          type: 'textarea',
          value: '',
          placeholder: this.$root.staticText.forms.placeholderComment2,
          error: false,
          valid: false,
          required: true,
          pattern: /\S{2,}/i,
        },
      ],
    }
  },
  watch: {
    'infoForm.success': function() {
      if (this.infoForm.success) {
        this.modalClose()
        this.modalType_successOpen({
          title: this.$root.staticText.modal.successTitleFeedback,
          text: this.$root.staticText.modal.successTextFeedback,
          class: '_small',
        })
      }
    },
    'infoForm.error': function() {
      if (this.infoForm.error) {
        this.modalClose()
        this.modalType_errorOpen({
          title: this.$root.staticText.modal.errorTitle,
          text: this.$root.staticText.modal.errorText,
          class: '_small',
        })
      }
    },
  },
  components: {
    'success-cmp': success,
    'error-cmp': error,
    VueRecaptcha,
  },
  methods: {
    ...mapActions('modal', ['modalType_successOpen', 'modalType_errorOpen', 'modalClose']),

    onCapchaRegister(recaptchaToken) {
      this.recaptchaToken = recaptchaToken
      if (this.isValid) {
        this.send()
      }
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
    },
    errorCaptcha() {
      console.log('errorCaptcha')
    },

    submitForm() {
      this.validate()

      if (this.isValid) {
        this.$refs.recaptcha.execute()
      }
    },
    validate() {
      this.isValid = validate(this.form, this.infoForm, this.$route)
    },
    send() {
      return { ...sendForm(this.form, this.infoForm, this.recaptchaToken) }
    },
    changePersonalDataFrom() {
      return { ...changePersonalDataFrom(this.infoForm) }
    },
    focusForm(i) {
      return { ...focusForm(this.form, i) }
    },
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/components/base/modals/full-version.vue